module.exports = __webpack_public_path__ + "/images/ico-vendedores-redes.d69081c.webp";